function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { MinusOutline, AddOutline } from 'antd-mobile-icons';
import useMergedState from 'rc-util/lib/hooks/useMergedState';
import getMiniDecimal, { toFixed } from '@rc-component/mini-decimal';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import Input from '../input';
import Button from '../button';
import { useConfig } from '../config-provider';
var classPrefix = "adm-stepper";
var defaultProps = {
  step: 1,
  disabled: false,
  allowEmpty: false
};
export function Stepper(p) {
  var props = mergeProps(defaultProps, p);
  var _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? 0 : _props$defaultValue,
      value = props.value,
      _onChange = props.onChange,
      disabled = props.disabled,
      step = props.step,
      max = props.max,
      min = props.min,
      inputReadOnly = props.inputReadOnly,
      digits = props.digits,
      stringMode = props.stringMode,
      formatter = props.formatter,
      parser = props.parser;

  var _useConfig = useConfig(),
      locale = _useConfig.locale; // ========================== Parse / Format ==========================


  var fixedValue = function fixedValue(value) {
    var fixedValue = digits !== undefined ? toFixed(value.toString(), '.', digits) : value;
    return fixedValue.toString();
  };

  var getValueAsType = function getValueAsType(value) {
    return stringMode ? value.toString() : value.toNumber();
  };

  var parseValue = function parseValue(text) {
    if (text === '') return null;

    if (parser) {
      return String(parser(text));
    }

    var decimal = getMiniDecimal(text);
    return decimal.isInvalidate() ? null : decimal.toString();
  };

  var formatValue = function formatValue(value) {
    if (value === null) return '';

    if (formatter) {
      return formatter(value);
    } else {
      return fixedValue(value);
    }
  }; // ======================== Value & InputValue ========================


  var _useMergedState = useMergedState(defaultValue, {
    value: value,
    onChange: function onChange(nextValue) {
      _onChange === null || _onChange === void 0 ? void 0 : _onChange(nextValue);
    }
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      mergedValue = _useMergedState2[0],
      setMergedValue = _useMergedState2[1];

  var _useState = useState(function () {
    return formatValue(mergedValue);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1]; // >>>>> Value


  function setValueWithCheck(nextValue) {
    if (nextValue.isNaN()) return;
    var target = nextValue; // Put into range

    if (min !== undefined) {
      var minDecimal = getMiniDecimal(min);

      if (target.lessEquals(minDecimal)) {
        target = minDecimal;
      }
    }

    if (max !== undefined) {
      var maxDecimal = getMiniDecimal(max);

      if (maxDecimal.lessEquals(target)) {
        target = maxDecimal;
      }
    } // Fix digits


    if (digits !== undefined) {
      target = getMiniDecimal(fixedValue(getValueAsType(target)));
    }

    setMergedValue(getValueAsType(target));
  } // >>>>> Input


  var handleInputChange = function handleInputChange(v) {
    setInputValue(v);
    var valueStr = parseValue(v);

    if (valueStr === null) {
      if (props.allowEmpty) {
        setMergedValue(null);
      } else {
        setMergedValue(defaultValue);
      }
    } else {
      setValueWithCheck(getMiniDecimal(valueStr));
    }
  }; // ============================== Focus ===============================


  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      focused = _useState4[0],
      setFocused = _useState4[1];

  var inputRef = React.useRef(null);

  function triggerFocus(nextFocus) {
    setFocused(nextFocus); // We will convert value to original text when focus

    if (nextFocus) {
      setInputValue(mergedValue !== null && mergedValue !== undefined ? String(mergedValue) : '');
    }
  }

  useEffect(function () {
    var _a, _b, _c;

    if (focused) {
      (_c = (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.select) === null || _c === void 0 ? void 0 : _c.call(_b);
    }
  }, [focused]); // Focus change to format value

  useEffect(function () {
    if (!focused) {
      setInputValue(formatValue(mergedValue));
    }
  }, [focused, mergedValue, digits]); // ============================ Operations ============================

  var handleOffset = function handleOffset(positive) {
    var stepValue = getMiniDecimal(step);

    if (!positive) {
      stepValue = stepValue.negate();
    }

    setValueWithCheck(getMiniDecimal(mergedValue !== null && mergedValue !== void 0 ? mergedValue : 0).add(stepValue.toString()));
  };

  var handleMinus = function handleMinus() {
    handleOffset(false);
  };

  var handlePlus = function handlePlus() {
    handleOffset(true);
  };

  var minusDisabled = function minusDisabled() {
    if (disabled) return true;
    if (mergedValue === null) return false;

    if (min !== undefined) {
      return mergedValue <= min;
    }

    return false;
  };

  var plusDisabled = function plusDisabled() {
    if (disabled) return true;
    if (mergedValue === null) return false;

    if (max !== undefined) {
      return mergedValue >= max;
    }

    return false;
  }; // ============================== Render ==============================


  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classNames(classPrefix, _defineProperty({}, "".concat(classPrefix, "-active"), focused))
  }, /*#__PURE__*/React.createElement(Button, {
    className: "".concat(classPrefix, "-minus"),
    onClick: handleMinus,
    disabled: minusDisabled(),
    fill: 'none',
    shape: 'rectangular',
    color: 'primary',
    "aria-label": locale.Stepper.decrease
  }, /*#__PURE__*/React.createElement(MinusOutline, null)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-middle")
  }, /*#__PURE__*/React.createElement(Input, {
    ref: inputRef,
    className: "".concat(classPrefix, "-input"),
    onFocus: function onFocus(e) {
      var _a;

      triggerFocus(true);
      (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
    },
    value: inputValue,
    onChange: function onChange(val) {
      disabled || handleInputChange(val);
    },
    disabled: disabled,
    onBlur: function onBlur(e) {
      var _a;

      triggerFocus(false);
      (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
    },
    readOnly: inputReadOnly,
    role: 'spinbutton',
    "aria-valuenow": Number(inputValue),
    "aria-valuemax": Number(max),
    "aria-valuemin": Number(min),
    inputMode: 'decimal'
  })), /*#__PURE__*/React.createElement(Button, {
    className: "".concat(classPrefix, "-plus"),
    onClick: handlePlus,
    disabled: plusDisabled(),
    fill: 'none',
    shape: 'rectangular',
    color: 'primary',
    "aria-label": locale.Stepper.increase
  }, /*#__PURE__*/React.createElement(AddOutline, null))));
}